export enum WrittenOffStatusIndicator {
	UNSET = 'UNSET',
	STATUS_CODE = 'STATUS_CODE',
	PRODUCT_CODE = 'PRODUCT_CODE',
	STATUS_CODE_OR_PRODUCT_CODE = 'STATUS_CODE_OR_PRODUCT_CODE',
	STATUS_CODE_AND_PRODUCT_CODE = 'STATUS_CODE_AND_PRODUCT_CODE',
	WRITTEN_OFF_DATE = 'WRITTEN_OFF_DATE',
	STATUS_CODE_OR_WRITTEN_OFF_DATE = 'STATUS_CODE_OR_WRITTEN_OFF_DATE',
	STATUS_CODE_AND_WRITTEN_OFF_DATE = 'STATUS_CODE_AND_WRITTEN_OFF_DATE',
	PRODUCT_CODE_OR_WRITTEN_OFF_DATE = 'PRODUCT_CODE_OR_WRITTEN_OFF_DATE',
	PRODUCT_CODE_AND_WRITTEN_OFF_DATE = 'PRODUCT_CODE_AND_WRITTEN_OFF_DATE',
	STATUS_CODE_OR_PRODUCT_CODE_OR_WRITTEN_OFF_DATE = 'STATUS_CODE_OR_PRODUCT_CODE_OR_WRITTEN_OFF_DATE',
	STATUS_CODE_AND_PRODUCT_CODE_AND_WRITTEN_OFF_DATE = 'STATUS_CODE_AND_PRODUCT_CODE_AND_WRITTEN_OFF_DATE',
}

export default WrittenOffStatusIndicator;
